import type { CSSProperties } from 'react';

import { Button } from './Button';

/**
 * Flacher Symbol-Button der Grid-Kommandospalten — Pendant zu
 * `CommandButtonOptions { IconCss, CssClass = "e-flat" }`.
 */
export interface IconButtonProps {
  iconClass: string;
  title?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void | Promise<void>;
}

export function IconButton(props: IconButtonProps) {
  return <Button flat {...props} />;
}

export default IconButton;
